import isPropValid from '@emotion/is-prop-valid';
import { get, isNil, isNull, isString } from 'lodash';

import { BaseStatus } from 'enums/common';

import { type OptionType, type QuestionType, type Values } from 'types/common';

export const isEmpty = (value: string | number | null | undefined): boolean =>
  isNil(value) || value === '';

export const isNonEmptyString = (value: unknown): value is string =>
  isString(value) && !!value.trim().length;

export const isTrue = (value: unknown): boolean => value === true;

export const isFalse = (value: unknown): boolean => value === false;

export const isNumberString = (value?: number | string): boolean =>
  !!value && /^\d+$/.test(`${value}`);

export const getBaseValue = (value: boolean): BaseStatus =>
  value ? BaseStatus.Yes : BaseStatus.No;

export const getOptionValue = (value: OptionType): QuestionType => {
  if (isNull(value)) {
    return null;
  }

  return getBaseValue(value);
};

export const getConditionalObject = <T extends object>(condition: boolean, obj: T): Partial<T> =>
  condition ? obj : {};

export const getConditionalArray = <T extends object>(condition: boolean, array: T[]): T[] =>
  condition ? array : [];

// Formik has onSubmit mandatory prop, so this function helps to mock it
export const mockedFunction = (): void => undefined;

export const getValidProps = (props: Values): Values =>
  Object.entries(props).reduce<Values>((acc, [key, value]) => {
    if (isPropValid(key)) {
      acc[key] = value;
    }

    return acc;
  }, {});

export const getOptionsFromArray = (array: string[]) =>
  array.map(value => ({
    value,
    label: value,
  }));

export const getEnvVariable = (key: string, fallbackValue: any) => {
  const value = get(window, key, {});
  const isEnvVarReplaced = !(value as string).startsWith?.('{{');

  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  if (isEnvVarReplaced) {
    return value;
  }

  return fallbackValue;
};

export const checkEnvNameVariable = (expectedValue: string, fallbackValue: any): boolean => {
  const value = get(window, 'environmentName', {});

  if (!value) {
    return fallbackValue;
  }

  return value === expectedValue;
};
